
// Standard categories shared between goals and advertisers
export const STANDARD_CATEGORIES = [
  "Finance",
  "Education",
  "Health",
  "Career",
  "Personal",
  "Family",
  "Travel",
  "Fitness",
  "Technology",
  "Lifestyle",
  "Mental Health",
  "Productivity",
  "Creativity",
  "Bucket List"
] as const;

export const BUCKET_LIST_CATEGORY = "Bucket List" as const;

export type StandardCategory = typeof STANDARD_CATEGORIES[number];

export const UAE_LOCATIONS = [
  "UAE",
  "Abu Dhabi",
  "Dubai",
  "Sharjah",
  "Ajman",
  "Umm Al Quwain",
  "Ras Al Khaimah",
  "Fujairah"
] as const;

export type UAELocation = typeof UAE_LOCATIONS[number];
